import { redpacketRepository } from '@/repositories/Index'

class RedpacketService {
	//扫码住兑换金账户明细列表
	async getExchangeAmtDetailListFn(params: any) {
		const res = await redpacketRepository.getExchangeAmtDetailList(params)
		return res
	}
	//扫码住酒店数据列表
	async getExchangeHotelDataListFn(params: any) {
		const res = await redpacketRepository.getExchangeHotelDataList(params)
		return res
	}
	//扫码住兑换金账户余额
	async getExchangeAmtBalanceFn() {
		const res = await redpacketRepository.getExchangeAmtBalance()
		return res
	}
	//扫码住兑换金面额关联红包活动
	async getExchangeRPkActivitInfoFn(params: any) {
		const res = await redpacketRepository.getExchangeRPkActivitInfo(params)
		return res
	}
	//扫码住兑换金兑换红包
	async exchangeRedPacketFn(params: any) {
		const res = await redpacketRepository.exchangeRedPacket(params)
		return res
	}
	async getUseRedPacket(params: any) {
		const res = await redpacketRepository.getUseRedPacket(params)
		return res
	}
	async getUserAlreadyGetList(params: any) {
		const res = await redpacketRepository.getUserAlreadyGetList(params)
		return res
	}

	// 促销活动规则接口
	async promotionRedPacketRuleFn(params: any) {
		const res = await redpacketRepository.promotionRedPacketRule(params)
		return res
	}
	// 红包可领取
	async getUseRedPacketFn(params: any) {
		const res = await redpacketRepository.getUseRedPacket(params)
		return res
	}
	// 用户下单可用红包列表
	async redPacketQueryAvailableFn(params: any) {
		const res = await redpacketRepository.redPacketQueryAvailable(params)
		return res
	}
	// 促销规则计算优惠金额接口
	async redPacketCalculatePriceFn(params: any) {
		const res = await redpacketRepository.redPacketCalculatePrice(params)
		return res
	}
	// 促销规则计算优惠金额接口
	async redPacketBatchReceive(params: any) {
		const res = await redpacketRepository.redPacketBatchReceive(params)
		return res
	}

	async getUserRedPacketCaution(params: any) {
		const res = await redpacketRepository.getUserRedPacketCaution(params)
		return res
	}

	async redPacketReceive(params: any) {
		const res = await redpacketRepository.redPacketReceive(params)
		return res
	}

	async redPacketActivate(params: any) {
		const res = await redpacketRepository.redPacketActivate(params)
		return res
	}

	async getCompaginButtonDisplay(params: any) {
		const res = await redpacketRepository.getCompaginButtonDisplay(params)
		return res
	}

	async checkExchangeRedPacket(params: any) {
		const res = await redpacketRepository.checkExchangeRedPacket(params)
		return res
	}
}

export default RedpacketService
